/*
 * @Author: zhaofy 
 * @Date: 2018-01-25 22:55:56 
 * @Last Modified by: zhaofy
 * @Last Modified time: 2018-02-27 21:31:55
 */
<template>
  <!-- 分页 -->
  <div class="paging" v-show="total !== 0">
    <span>共{{total}}条记录</span>
    <span>{{pageNo}}/{{pages}}</span>
    <span class="skip">
      <span v-show="no > 1" @click.stop.prevent="cSwitchPage('leftMore')">|<</span>
      <span v-show="no > 1" @click.stop.prevent="cSwitchPage('left')"><<</span>
      <span v-show="no > 1" @click.stop.prevent="cSwitchPage('last')">{{no - 1}}</span>
      <span class="seleted">{{no}}</span>
      <span v-show="no < pages" @click.stop.prevent="cSwitchPage('next')">{{no + 1}}</span>
      <span v-show="no < pages" @click.stop.prevent="cSwitchPage('right')">>|</span>
      <span v-show="no < pages" @click.stop.prevent="cSwitchPage('rightMore')">>></span>
      <div class="text" @mouseover="showArrow = true" @mouseout="showArrow = false">
        <input type="text" v-model="pageNum">
        <div v-show="showArrow" class="arrow">
          <span class="arrow-up" @click.stop.prevent="revisePage('up')"></span>
          <span class="arrow-down" @click.stop.prevent="revisePage('down')"></span>
        </div>
      </div>
      <span @click.stop.prevent="cSwitchPage('jump')">跳转</span>
    </span>
  </div>
</template>
<script>
  export default {
    name: 'paging',
    props: {
      no: [Number], // 当前页数
      total: [Number], // 总共数据
      pages: [Number], // 总共页数
      getList: [Function] // 请求数据方法
    },
    data () {
      return {
        pageNum: 1, // 输入框
        showArrow: false, // 显示输入框中小三角
        pageNo: this.no // 当前页数
      }
    },
    watch: {
      // 监听输入框，小于1或大于最大页数，重置为1
      pageNum () {
        if (this.pageNum < 1 && this.pageNum > this.pages) this.pageNum = 1
      }
    },
    methods: {
      /**
       * [cSwitchPage 分页切换]
       * @param  {[String]} direct  []
       * @return {[type]}        [description]
       */
      cSwitchPage (direct) {
        if (direct === 'left' || direct === 'last') { // 上一页
          this.$emit('update:no', --this.pageNo)
        } else if (direct === 'right' || direct === 'next') { // 下一页
          this.$emit('update:no', ++this.pageNo)
        } else if (direct === 'leftMore') { // 第一页
          this.pageNo = 1
          this.$emit('update:no', 1)
        } else if (direct === 'rightMore') { // 最后一页
          this.pageNo = this.pages
          this.$emit('update:no', this.pages)
        } else if (direct === 'jump') { // 根据输入跳转
          this.pageNo = Number(this.pageNum)
          this.$emit('update:no', Number(this.pageNum))
        }
        this.pageNum = this.pageNo
        // 请求数据
        this.getList()
      },
      /**
       * [revisePage 修改输入框的值]
       * @param  {[type]} rp [up or down]
       * @return {[type]}    [description]
       */
      revisePage (rp) {
        if (rp === 'up' && this.pageNum < this.pages) {
          this.pageNum++
        } else if(rp === 'down' && this.pageNum > 1) {
          this.pageNum--
        }
      }
    }
  }
</script>
<style scoped lang="less">
  .paging{
    margin: 20px;
    height: 38px;
    span{
      display: inline-block;
      letter-spacing: normal;
      margin: 0 0 0 -1px;
      vertical-align: top;
      word-spacing: normal;
      border: 1px solid #e6e6e6;
      color: #aaa;
      display: block;
      font: 14px/20px "microsoft yahei";
      min-width: 20px;
      padding: 8px;
      position: relative;
      text-align: center;
      z-index: 1;
      float: left;
    }
    span.skip {
      margin-left: 10px;
      padding: 0;
      border: 0;
      span:not(.seleted){
        cursor: pointer;
      }
      .text{
        float: left;
      }
      input{
        box-shadow: none;
        float: left;
        width: 80px;
        border: 1px solid #e6e6e6;
        color: #aaa;
        padding: 8px;
        font: 12px/20px Tahoma, Helvetica, Arial, "\5b8b\4f53", sans-serif;
        background-color: #fff;
        outline: none;
      }
    }
    .arrow{
      position: relative;
      float: left;
      margin: 9px 0px 9px -45px;
      height: 20px;
      &:hover{
        cursor: pointer;
      }
      span{
        margin-left: 20px;
        padding: 0;
        min-width:0px;
      }
      &-up{
        /*CSS 写出三角形*/
        width:0px;
        height:0px;
        border-left:5px solid transparent;  /* left arrow slant */
        border-right:5px solid transparent; /* right arrow slant */
        border-bottom:5px solid #999; /* bottom, add background color here */
        font-size:0px;
        line-height:0px;
        &:hover{
          border-bottom-color: #2f2f2f
        }
      }
      &-down{
        position: absolute;
        bottom:0px;
        width:0px;
        height:0px;
        border-left:5px solid transparent;
        border-right:5px solid transparent;
        border-top:5px solid #999;
        font-size:0px;
        line-height:0px;
        &:hover{
          border-top-color: #2f2f2f
        }
      }
    }
    .seleted{
      background-color: #f5f5f5;
      border-color: #ddd;
      color: #aaa;
      font-weight: bold;
    }
  }
</style>


// WEBPACK FOOTER //
// module-paging.vue?54583e15